import { useState, useEffect, useContext } from 'react';
import CompanyService from 'services/company2';
import { formatDate } from 'lib/formatter.ts';
import Paper from '@material-ui/core/Paper';
import Http from 'services/http2';
import { MediaBox } from 'react-weui';
import Util from 'lib/util';
import * as React from 'react';

function OrderOssList(props) {
  const { billNo, companyCode, customerCode } = props;
  const [list, setList] = useState([]);

  //根据依赖多次执行
  useEffect(() => {
    let postbody = {
      billNo: billNo,
      companyCode: companyCode || customerCode,
      apiPath: '/oss/blog/list'
    };
    if (customerCode) {
      postbody = {
        companyCodes: [companyCode, customerCode],
        billNo: billNo,
        apiPath: '/oss/blog/listByComp'
      };
    }
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let logList = Util.listSort(response.data, 'createTime', 'desc');
        setList(logList);
      }
    });
  }, [companyCode, billNo, customerCode]);
  return (
    <Paper elevation={0} square style={{ padding: '10px 10px 70px' }}>
      <div className="order-detail-list price-compare-list">
        <div className="m-list-item">
          {list?.length > 0 &&
            list.map((item, index) => (
              <MediaBox key={index}>
                <ul className="clearfix main">
                  <li>
                    <label>操作日期：</label>
                    <div>
                      {formatDate(item.createTime, 'YYYY-MM-DD HH: mm: ss')}
                    </div>
                  </li>
                  <li>
                    <label>操作人：</label>
                    <div>{item.employeeName}</div>
                  </li>
                  <li>
                    <label>操作内容：</label>
                    <div>{item.operateContent}</div>
                  </li>
                  <li>
                    <label>说明：</label>
                    <div>{item.description}</div>
                  </li>
                </ul>
              </MediaBox>
            ))}
        </div>
      </div>
    </Paper>
  );
}
export default OrderOssList;
